angular.module('wbControllers').controller 'StaffDashboardController',
['$scope', '$location','Stats',
($scope, $location, Stats) ->
  $scope.stats = Stats.get {}, (stats) ->
    stats.olderThanMinute = moment().diff(stats.dataValidAsOf) > 60*1000

  $scope.onSelect = (item, model, label) ->
    $location.url("clients/#{item.id}")
]
